import React, { Dispatch, SetStateAction, useState } from "react";
import * as styles from "./FooterDisclaimer.module.scss";

import { i18n } from "@lingui/core";
import { LanguageCode } from "src/utils/localization/languages/types";
import { Trans } from "@lingui/react/macro";
import {
  defaultCaptchaErrorHandler,
  FriendlyCaptcha
} from "components/WebQuoteModal/FriendlyCaptcha/FriendlyCaptcha";
import { WebQuoteError } from "components/WebQuoteModal/utils";
import { useFriendlyCaptchaStatus } from "components/WebQuoteModal/FriendlyCaptcha/FriendlyCaptchaProvider";

type FooterDisclaimerProps = {
  validationError: WebQuoteError | undefined;
};

export const FooterDisclaimer: React.FC<FooterDisclaimerProps> = ({
  validationError
}) => {
  const { setCaptchaSolution } = useFriendlyCaptchaStatus();
  return (
    <div className={styles.disclaimerText}>
      <Trans>
        By submitting this form, I agree to receive electronic messages from
        Silversea including the latest news and offers. I may however
        unsubscribe from any communications at any time by clicking on this link
        or visiting my MySilversea profile. Silversea Cruises Ltd., Silversea
        Cruises Ltd. 1050 Caribbean Way, Miami, FL 33131 United States,
        +1-800-722-9955
      </Trans>

      <div className={styles.captcha}>
        <FriendlyCaptcha
          doneCallback={setCaptchaSolution}
          errorCallback={defaultCaptchaErrorHandler}
          languageCode={i18n.locale as LanguageCode}
          validationError={validationError}
        />
      </div>
    </div>
  );
};
